const custom = require("@/custom/customConfig.json")
const customConfig = {
  install(Vue: any, options: any) {
    const project = `${process.env.VUE_APP_PROJECT_NAME}CustomConfig`
    if (project) {
      const module = require(`@/custom/${project}.json`)
      Vue.prototype.$customConfig = {
        ...custom,
        ...module
      }
    } else {
      Vue.prototype.$customConfig = custom
    }
  }
}
export default customConfig;
